import { render, staticRenderFns } from "./MenuLabel.vue?vue&type=template&id=57dcda70&scoped=true&"
import script from "./MenuLabel.vue?vue&type=script&lang=js&"
export * from "./MenuLabel.vue?vue&type=script&lang=js&"
import style0 from "./MenuLabel.vue?vue&type=style&index=0&id=57dcda70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dcda70",
  null
  
)

export default component.exports